import { configureStore } from '@reduxjs/toolkit';
import checklistReducer from '../features/checklists/checklistSlice';
import checklistsReducer from '../features/checklists/checklistsSlice';
import goalReducer from '../features/goals/goalSlice';
import goalsReducer from '../features/goals/goalsSlice';
import measurementReducer from '../features/measurements/measurementSlice';
import measurementsReducer from '../features/measurements/measurementsSlice';
import authReducer from '../features/signin/authSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    checklist: checklistReducer,
    checklists: checklistsReducer,
    goal: goalReducer,
    goals: goalsReducer,
    measurement: measurementReducer,
    measurements: measurementsReducer,
  }
});

const state = store.getState();
export type RootState = typeof state;

export type AppDispatch = typeof store.dispatch;

export default store;
